










import { Component, Vue } from 'vue-property-decorator';
import ProductIntroIndex from './ProductIntroIndex.vue';
import CourseIntro from './CourseIntro.vue';
import CourseIter from './CourseIter.vue';
import ExamIntro from './ExamIntro.vue';
import OJIntro from './OJIntro.vue';

@Component({
  name: 'product-intro',
  components: {
    ProductIntroIndex,
    CourseIntro,
    CourseIter,
    ExamIntro,
    'oj-intro': OJIntro,
  },
})
export default class ProductIntro extends Vue { }
